import { Stack, TextField, Typography } from "@mui/material";

const inputFieldStyles = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 2,
  },
  "& input": {
    textAlign: "center",
    fontSize: 18,
    fontWeight: 500,
    width: 80,
  },
};

const unitStyles = {
  fontSize: 18,
  fontWeight: 600,
  color: "neutral.900",
};

export interface SingleVitalInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  ariaLabel: string;
  unit: string;
  min?: number;
  max?: number;
}

export function SingleVitalInput({
  value,
  onChange,
  placeholder,
  ariaLabel,
  unit,
  min = 0,
  max = 300,
}: SingleVitalInputProps) {
  return (
    <Stack direction="row" alignItems="center" gap={1.5}>
      <TextField
        value={value}
        onChange={(e) => onChange(e.target.value)}
        type="number"
        placeholder={placeholder}
        inputProps={{
          "aria-label": ariaLabel,
          min,
          max,
        }}
        sx={inputFieldStyles}
      />
      <Typography sx={unitStyles}>{unit}</Typography>
    </Stack>
  );
}

export interface BloodPressureInputProps {
  systolic: string;
  diastolic: string;
  onSystolicChange: (value: string) => void;
  onDiastolicChange: (value: string) => void;
  systolicLabel: string;
  diastolicLabel: string;
  unit: string;
}

export function BloodPressureInput({
  systolic,
  diastolic,
  onSystolicChange,
  onDiastolicChange,
  systolicLabel,
  diastolicLabel,
  unit,
}: BloodPressureInputProps) {
  return (
    <Stack direction="row" alignItems="center" gap={1.5}>
      <TextField
        value={systolic}
        onChange={(e) => onSystolicChange(e.target.value)}
        type="number"
        placeholder="120"
        inputProps={{
          "aria-label": systolicLabel,
          min: 0,
          max: 300,
        }}
        sx={inputFieldStyles}
      />
      <Typography
        sx={{
          fontSize: 24,
          fontWeight: 500,
          color: "neutral.700",
        }}
      >
        /
      </Typography>
      <TextField
        value={diastolic}
        onChange={(e) => onDiastolicChange(e.target.value)}
        type="number"
        placeholder="80"
        inputProps={{
          "aria-label": diastolicLabel,
          min: 0,
          max: 200,
        }}
        sx={inputFieldStyles}
      />
      <Typography sx={{ ...unitStyles, ml: 1 }}>{unit}</Typography>
    </Stack>
  );
}
